import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { CatalogoActividadesVinculacionDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class CatalogoActividadesVinculacionService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getCatalogoActividadesVinculacionService(): Observable<BodyListResponse<CatalogoActividadesVinculacionDTO>> {
    return this.http.get<BodyListResponse<CatalogoActividadesVinculacionDTO>>(API_URL + '/api/v1/catalogoActividadesVinculacion/todos');
  }

  guardarCatalogoActividadesVinculacionService(catalogoActividadesVinculacionDTO: CatalogoActividadesVinculacionDTO): Observable<CatalogoActividadesVinculacionDTO> {
    return this.http.post<CatalogoActividadesVinculacionDTO>(API_URL + '/api/v1/catalogoActividadesVinculacion', catalogoActividadesVinculacionDTO);
  }

  getCatalogoActividadesVinculacionPorCodigoCatalogoActividadesVinculacionService(codigoCatalogoActividadesVinculacion: string): Observable<BodyResponse<CatalogoActividadesVinculacionDTO>> {
    return this.http.get<BodyResponse<CatalogoActividadesVinculacionDTO>>(API_URL + '/api/v1/catalogoActividadesVinculacion/' + codigoCatalogoActividadesVinculacion);
  }
}
